import React from "react";
const IconElement = ({
  value,
  className
}) => {
  const iconName = typeof value === "string" ? value : value?.value;
  return /*#__PURE__*/React.createElement("i", {
    className: `la la-${iconName} ${className}`
  });
};
export default IconElement;
//# sourceMappingURL=IconElement.js.map